__webpack_require__.p = "/Space-Tourism/";